module.exports = __webpack_public_path__ + "static/media/01C.71ce68df.png";